import { EXPORT_VARIABLE_TYPES, VARIABLE_STYLE } from "types/engineExport.types"
// Define enum for file types
export enum DATAFILE_TYPE {
  CSV = "csv",
  MAP = "map",
  JSON = "json",
  DQD = "dqd",
}

// Define type for size parameter for datafileGet - for checking if the file exists
export type DatafileSizeOption = "size" | ""

//DataFileItem interface for each data file item in the table
export interface DataFileItem {
  key: string
  fileType: string
  isUploaded: boolean
  type: DATAFILE_TYPE
}

// Define the additional values for map generation
export interface GenerateMapValues {
  groupSections?: boolean
  variableNames?: EXPORT_VARIABLE_TYPES
  variableStyle?: VARIABLE_STYLE
  includeQuestionText?: boolean
}

// Define the API response structure for generate map
export interface GenerateMapResponse {
  data: {
    result: {
      message: string
    }
  }
}

// Response type for combine data files
export interface CombineDataFilesResponse {
  data: {
    result?: {
      message?: string
      warnings?: string
    }
    // Legacy format support
    message?: string
    warnings?: string
    // What the import did to the project history: "recorded", "unchanged", or "not_recorded"
    // (the data is stored, the history entry wasn't written; `reason` says why)
    auditStatus?: string
    reason?: string
  } | string
}

// Import method options for data import UI
export type ImportMethod = "csv_map" | "json" | "dqd" | "dummy"

// Machine-readable classification the engine puts on each import message as a `[code] `
// prefix. "other" covers unprefixed or unrecognised lines.
export type ImportWarningCode =
  | "missing"
  | "convert"
  | "case"
  | "rename"
  | "related"
  | "unmapped"
  | "dropped"
  | "datamap"
  | "other"

export interface ImportWarning {
  code: ImportWarningCode
  text: string
}

// A not-imported column whose name contains a variable that IS in the datamap — the decorated
// twins a scripting platform emits ("noanswer<var>", "<var>oe"). Worth separating from genuine
// system columns because it usually points at a setup problem.
export interface RelatedUnmappedColumn {
  column: string
  relatedTo: string
}

// The `[unmapped]` message body: a JSON inventory of every column that was not imported.
export interface UnmappedColumnsPayload {
  count: number
  related: RelatedUnmappedColumn[]
  other: string[]
}
